import { mockResponse } from '../errors/examples';
import { activitiesMock, getInstallmentsMock, getPolicesMock, personByDocumentMock1, personByDocumentMock2, postNotificationMock, postOffersMock, postPeopleCompleteMock, postRequestMock, postValidateMock, postVerifyMock, putPeopleMock } from './examples';
import ENABLE from '../enable';

const isDevelopmentEnv = ['dev'].some(env => process.env.NODE_ENV.includes(env));
export const mock = (ENABLE?.enableMock && isDevelopmentEnv) ? {
    loanFlow: {
        getActivities: {
            enable: true,
            response: mockResponse(activitiesMock)
        },
        personByDocumentExample1: {
            enable: true,
            response: mockResponse(personByDocumentMock1)
        },
        personByDocumentExample2: {
            enable: true,
            response: mockResponse(personByDocumentMock2)
        },
        putPeople: {
            enable: true,
            response: mockResponse(putPeopleMock)
        },
        getPolicies: {
            enable: true,
            response: mockResponse(getPolicesMock)
        },
        postOffers: {
            enable: true,
            response: mockResponse(postOffersMock)
        },
        getInstallments: {
            enable: true,
            response: mockResponse(getInstallmentsMock)
        },
        postVerify: {
            enable: true,
            response: mockResponse(postVerifyMock)
        },
        postValidate: {
            enable: true,
            response: mockResponse(postValidateMock)
        },
        postPeopleComplete: {
            enable: true,
            response: mockResponse(postPeopleCompleteMock)
        },
        postRequest: {
            enable: true,
            response: mockResponse(postRequestMock)
        },
        postNotification: {
            enable: true,
            response: mockResponse(postNotificationMock)
        },
    }
} : {};
